import { BoxSpg, CardSpg, SuccessAlert, useRedirect, useScroll } from "@duosoftbg/nacid-components";
import CardContent from "@mui/material/CardContent/CardContent";
import PageWrapper from "../../../common/layout/PageWrapper";
import { useTranslation } from "react-i18next";
import React, { useEffect } from "react";
import { Button } from "@mui/material";
import { ProcessEnvironments } from "@duosoftbg/nacid-frontoffice-components";

const RegistrationSuccess = ({ userDetails }) => {
  const { t } = useTranslation();
  const { scrollToTop } = useScroll();
  const { redirect } = useRedirect();

  useEffect(() => {
    scrollToTop();
    // eslint-disable-next-line
  }, []);

  return (
    <PageWrapper title={t("t.page.registration.success")}>
      <CardSpg my={4} style={{ overflow: "visible" }}>
        <CardContent style={{ padding: 24, position: "relative" }}>
          <SuccessAlert
            message={"m.registration.success"}
            withParse={true}
            dynamicValuesObject={{ username: userDetails.username, email: userDetails.email }}
          />
          <BoxSpg mt={2}>
            <Button
              fullWidth
              variant={"contained"}
              color={"success"}
              onClick={() => redirect(`${ProcessEnvironments.PublicUrl}/home`)}
            >
              {t("l.btn.home")}
            </Button>
          </BoxSpg>
        </CardContent>
      </CardSpg>
    </PageWrapper>
  );
};
export default RegistrationSuccess;
